import { VOICE_NOTES, VOICE_POSTS, VOICE_WALL_HASHTAG_URL, VoiceWall as SharedVoiceWall, voiceWallSources, type VoiceNote, type VoicePost } from "@noiman/ui/voice-wall";

/**
 * HP の受講生の声に置く、受講生の投稿の壁。壁の本体 (部品、データ、CSS) は packages/shared-ui の VoiceWall が正本で、
 * 適職診断の結果の頁 (apps/client) と同じ物を使う。ここは HP の見出しと説明の文だけを持つ。
 * 足し方は packages/shared-ui/src/components/domain/VoiceWall/voice-posts.ts (X) と voice-notes.ts (note) の頭に書いた。
 * 両方とも空のあいだは何も描かない。
 */
export function VoiceWall({ posts = VOICE_POSTS, notes = VOICE_NOTES }: { posts?: VoicePost[]; notes?: VoiceNote[] }) {
  const sources = voiceWallSources(posts, notes);
  if (!sources) return null;
  return (
    <div className="hx-wall-box">
      <div className="hx-vf-hd">
        <p className="hx-vf-t">
          <span className="hx-k">{sources}</span>
          受講生の投稿
        </p>
        <p className="hx-vf-links">
          <a href={VOICE_WALL_HASHTAG_URL} target="_blank" rel="noopener noreferrer" className="hx-tlink hx-vf-more">
            #ゆめさくエンジニア の記事をもっと読む（note）
          </a>
        </p>
      </div>
      <p className="hx-nb-lede">受講生が {sources === "X・note" ? "X と note" : sources} に自分で公開した投稿を、原文のまま載せています。押すと元の投稿が開きます。</p>
      <SharedVoiceWall posts={posts} notes={notes} />
    </div>
  );
}
